import { Host, h, } from "@stencil/core";
import { formTooltipLogic } from "../../common/form";
import { formClasses } from "../../common/classesNames";
import { commonClassesNames } from "../../common/classesNames";
import { detectClickOutside } from "../../common/detect-click-outside";
export class GxgTitleEditable {
    constructor() {
        this.value = undefined;
        this.titleType = "h1";
        this.disableEdition = false;
        this.debounce = false;
        this.debounceDelay = 800;
        this.disabled = false;
        this.clickToEdit = false;
        this.fluid = false;
        this.focusType = undefined;
        this.validationStatus = "indeterminate";
        this.validationMessage = undefined;
        this.hideTooltip = false;
        this.editing = false;
    }
    textInput;
    wrapperEl;
    editButtonEl;
    ghostDiv;
    el;
    timeoutReference;
    watchValueHandler(newValue) {
        if (this.debounce) {
            clearTimeout(this.timeoutReference);
            this.timeoutReference = setTimeout(() => {
                this.valueChanged.emit(newValue);
            }, this.debounceDelay);
        }
        else {
            this.valueChanged.emit(newValue);
        }
    }
    watchEditingHandler(editing) {
        if (editing) {
            document.addEventListener("click", this.detectClickOutsideFunc);
        }
        else {
            document.removeEventListener("click", this.detectClickOutsideFunc);
        }
    }
    /* EVENTS */
    /**
     * Emitted when the value changes
     */
    valueChanged;
    /*COMPONENT LIFECYCLE METHODS*/
    componentDidLoad() {
        if (this.fluid) {
            this.inputInputHandler();
        }
    }
    /*PRIVATE METHODS*/
    edit = () => {
        this.editing = true;
        this.positionCursorAtTheEnd();
    };
    wrapperClickedHandler = () => {
        this.editing = true;
    };
    positionCursorAtTheEnd = () => {
        this.textInput.selectionStart = this.textInput.selectionEnd = this.textInput.value.length;
        this.textInput.focus();
    };
    inputKeyDownHandler = (e) => {
        if (e.key === "Enter" || e.key === "Escape") {
            e.preventDefault();
            this.editing = false;
            this.editButtonEl.focus();
        }
        else if (this.fluid) {
            this.setInputWidth();
        }
    };
    detectClickOutsideFunc = (e) => {
        const clickedOutside = detectClickOutside(e, this.wrapperEl);
        if (clickedOutside) {
            this.editing = false;
        }
    };
    setInputWidth = () => {
        this.textInput.style.width = this.value.length + 1 + "ch";
    };
    inputInputHandler = () => {
        this.value = this.textInput.value;
        if (this.fluid) {
            this.ghostDiv.innerText = this.value;
            this.updateInputWidth();
        }
    };
    updateInputWidth = () => {
        if (this.fluid) {
            const ghostDivWidth = this.ghostDiv.getBoundingClientRect().width;
            this.textInput.style.width = `${ghostDivWidth}px`;
        }
    };
    /*RENDER*/
    render() {
        return (h(Host, { class: {
                editing: this.editing,
                "focus--text": this.focusType === "text",
                "focus--line": this.focusType === "line",
                [formClasses["VALIDATION_INDETERMINATE_CLASS"]]: this.validationStatus === "indeterminate",
                [formClasses["VALIDATION_WARNING_CLASS"]]: this.validationStatus === "warning",
                [formClasses["VALIDATION_ERROR_CLASS"]]: this.validationStatus === "error",
                [formClasses["VALIDATION_SUCCESS_CLASS"]]: this.validationStatus === "success",
                [commonClassesNames["DISABLED_CLASS"]]: this.disabled,
            } }, h("div", { onMouseUp: this.clickToEdit &&
                !this.editing &&
                !this.disableEdition &&
                this.wrapperClickedHandler, class: {
                wrapper: true,
            }, ref: (el) => (this.wrapperEl = el) }, this.fluid ? (h("div", { class: "ghost", ref: (el) => (this.ghostDiv = el) })) : null, h("input", { type: "text", value: this.value, readOnly: !this.editing, ref: (el) => (this.textInput = el), onKeyDown: this.inputKeyDownHandler, onInput: this.inputInputHandler, tabIndex: this.editing ? 0 : -1 }), !this.disableEdition ? (h("gxg-button", { type: "secondary-icon-only", icon: "gemini-tools/edit", onClick: this.edit, ref: (el) => (this.editButtonEl = el) })) : null, formTooltipLogic(this, this.hideTooltip))));
    }
    static get is() { return "gxg-title-editable"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["title-editable.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["title-editable.css"]
        };
    }
    static get properties() {
        return {
            "value": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The title value"
                },
                "attribute": "value",
                "reflect": false,
                "defaultValue": "undefined"
            },
            "titleType": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "EditableTitleType",
                    "resolved": "\"h1\" | \"h2\" | \"h3\" | \"h4\"",
                    "references": {
                        "EditableTitleType": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/title-editable/title-editable.tsx",
                            "id": "src/components/title-editable/title-editable.tsx::EditableTitleType"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The title type"
                },
                "attribute": "title-type",
                "reflect": true,
                "defaultValue": "\"h1\""
            },
            "disableEdition": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If true, the title will not be editable"
                },
                "attribute": "disable-edition",
                "reflect": true,
                "defaultValue": "false"
            },
            "debounce": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute activates a debounce for the valueChanged event. This will cause the event to be emitted after 'debounceDelay' time."
                },
                "attribute": "debounce",
                "reflect": false,
                "defaultValue": "false"
            },
            "debounceDelay": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The debounce delay value. Only applies if 'debounce' is true."
                },
                "attribute": "debounce-delay",
                "reflect": false,
                "defaultValue": "800"
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute makes the input disabled"
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            },
            "clickToEdit": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If true, it will allow the title to be edited"
                },
                "attribute": "click-to-edit",
                "reflect": true,
                "defaultValue": "false"
            },
            "fluid": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If true, the width of the title will take only the minimum needed space"
                },
                "attribute": "fluid",
                "reflect": true,
                "defaultValue": "false"
            },
            "focusType": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "EditableTitleFocusType",
                    "resolved": "\"line\" | \"text\"",
                    "references": {
                        "EditableTitleFocusType": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/title-editable/title-editable.tsx",
                            "id": "src/components/title-editable/title-editable.tsx::EditableTitleFocusType"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If true, the width of the title will take only the minimum needed space"
                },
                "attribute": "focus-type",
                "reflect": true
            },
            "validationStatus": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "ValidationStatus",
                    "resolved": "\"error\" | \"indeterminate\" | \"success\" | \"warning\"",
                    "references": {
                        "ValidationStatus": {
                            "location": "import",
                            "path": "../../common/types",
                            "id": "src/common/types.ts::ValidationStatus"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The validation status"
                },
                "attribute": "validation-status",
                "reflect": false,
                "defaultValue": "\"indeterminate\""
            },
            "validationMessage": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The message to display when validation fails (error)"
                },
                "attribute": "validation-message",
                "reflect": false
            },
            "hideTooltip": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Shows or hides the tooltip"
                },
                "attribute": "hide-tooltip",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "editing": {}
        };
    }
    static get events() {
        return [{
                "method": "valueChanged",
                "name": "valueChanged",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emitted when the value changes"
                },
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "el"; }
    static get watchers() {
        return [{
                "propName": "value",
                "methodName": "watchValueHandler"
            }, {
                "propName": "editing",
                "methodName": "watchEditingHandler"
            }];
    }
}
//# sourceMappingURL=title-editable.js.map
